import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import CMRRoutes from "routes/routes";
import { ThemeProvider } from "@mui/material";
import theme from "./theme/theme";
import Notifications from "./components/notification/NotificationComponent";

const App: React.FC = (): JSX.Element => (
    <BrowserRouter>
        <ThemeProvider theme={theme}>
            <CMRRoutes />
            <Notifications />
        </ThemeProvider>
    </BrowserRouter>
);

export default App;
